.pre-prompt-modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;



    .pre-prompt-content {
        background-color: white;
        height: 500px;
        width: 60%;
        position: absolute;
        top: 20%;
        left: 20%;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        color: black;
        overflow-y: auto;
        border: 1px solid lightgray;

        &.disclaimer-modal {
            height: 100px;

            .disclaimer-content {
                font-size: 14px;
                font-weight: 500;
            }

        }

        .prompts-content {
            padding: 10px;

            .title {
                font-size: 14px;
                font-weight: 700;
            }

            .prompt-option {
                color: rgb(16, 3, 130);
                cursor: pointer;
                margin-bottom: 5px;
                font-size: 12px;
            }
        }





        header {
            height: 40px;
            background-color: rgb(43, 43, 43);
            padding: 10px;
            color: white;
            font-weight: 800;
            font-size: 16px;
            vertical-align: middle;
        }


    }


    .close-button {
        color: white;
        position: absolute;
        top: 10px;
        right: 18px;
        font-weight: 800;
        display: block;
        font-size: 16px;
        cursor: pointer;
    }
}